const CB_ECONOMICS = { donationPct: 0.05, platformPct: 0.08, shippingBRL: 18 } as const;

export type CheckoutBreakdown = {
  subtotal: number;
  shipping: number;
  total: number;
  donation: number;
  platform: number;
  assocShare: number;
  shippingRegion: string;
  shippingEtaDays: number;
};

type ShippingQuote = { price: number; etaDays: number; region: string };

const REGIONS: Record<string, { states: string[]; price: number; etaDays: number }> = {
  sudeste: { states: ['SP', 'RJ', 'MG', 'ES'], price: 18, etaDays: 3 },
  sul: { states: ['PR', 'SC', 'RS'], price: 24, etaDays: 4 },
  centro_oeste: { states: ['DF', 'GO', 'MT', 'MS'], price: 32, etaDays: 5 },
  nordeste: { states: ['BA', 'SE', 'AL', 'PE', 'PB', 'RN', 'CE', 'PI', 'MA'], price: 36, etaDays: 7 },
  norte: { states: ['AC', 'AM', 'AP', 'PA', 'RO', 'RR', 'TO'], price: 48, etaDays: 10 },
};

export const quoteShipping = (state: string | null | undefined): ShippingQuote => {
  if (!state) return { price: CB_ECONOMICS.shippingBRL, etaDays: 5, region: 'unknown' };
  const upper = state.toUpperCase();
  const entry = Object.entries(REGIONS).find(([, v]) => v.states.includes(upper));
  if (!entry) return { price: CB_ECONOMICS.shippingBRL, etaDays: 5, region: 'unknown' };
  const [name, meta] = entry;
  return { price: meta.price, etaDays: meta.etaDays, region: name };
};

export const calcBreakdown = (productPrice: number, shipState?: string | null): CheckoutBreakdown => {
  const subtotal = productPrice;
  const quote = quoteShipping(shipState);
  const shipping = quote.price;
  const total = subtotal + shipping;
  const donation = subtotal * CB_ECONOMICS.donationPct;
  const platform = subtotal * CB_ECONOMICS.platformPct;
  const assocShare = subtotal - donation - platform;
  return {
    subtotal,
    shipping,
    total,
    donation,
    platform,
    assocShare,
    shippingRegion: quote.region,
    shippingEtaDays: quote.etaDays,
  };
};
